import { Flex, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';
import { PlatformInstagramColorIcon } from 'ui-components/dist/PlatformInstagramColorIcon';
import { PlatformSnapchatColorIcon } from 'ui-components/dist/PlatformSnapchatColorIcon';
import { PlatformTikTokColorIcon } from 'ui-components/dist/PlatformTikTokColorIcon';
import { PlatformYouTubeColorIcon } from 'ui-components/dist/PlatformYouTubeColorIcon';
import { Select, SelectOption } from 'ui-components/dist/Select';
import { SOCIAL_PLATFORMS } from 'ui-components/dist/platforms';
import {
  ALL_SOCIAL_PLATFORM_TYPE,
  PARTIALLY_SUPPORTED_PLATFORMS,
  SOCIAL_PLATFORMS_NAMES,
} from '~/constants';
import { PLATFORM_OPTIONS } from '~/screens/WhalarModeScreen/components/PlatformsToggle';
import { useAdvancedFiltersStore } from '~/screens/store';
import { FILTERS } from '~/screens/types';

import { FollowersMetrics } from './FollowersMetrics';

export const selectOptions = [
  {
    label: 'Select Platform',
    value: 'Select Platform',
    icon: null,
    myAgencytrackId: 'foam-talent-filter-all-platforms',
    creatorMarketertrackId: 'foam-creatormarketer-talent-filter-all-platforms',
  },
  {
    label: SOCIAL_PLATFORMS_NAMES.instagram,
    icon: PlatformInstagramColorIcon,
    value: SOCIAL_PLATFORMS.instagram,
    myAgencytrackId: 'foam-talent-filter-instagram',
    creatorMarketertrackId: 'foam-creatormarketer-talent-filter-instagram',
  },
  {
    label: SOCIAL_PLATFORMS_NAMES.snapchat,
    icon: PlatformSnapchatColorIcon,
    value: PARTIALLY_SUPPORTED_PLATFORMS.snapchat,
    myAgencytrackId: 'foam-talent-filter-snapchat',
    creatorMarketertrackId: 'foam-creatormarketer-talent-filter-snapchat',
  },
  {
    label: SOCIAL_PLATFORMS_NAMES.tiktok,
    icon: PlatformTikTokColorIcon,
    value: SOCIAL_PLATFORMS.tiktok,
    myAgencytrackId: 'foam-talent-filter-tiktok',
    creatorMarketertrackId: 'foam-creatormarketer-talent-filter-tiktok',
  },
  {
    label: SOCIAL_PLATFORMS_NAMES.youtube,
    icon: PlatformYouTubeColorIcon,
    value: SOCIAL_PLATFORMS.youtube,
    myAgencytrackId: 'foam-talent-filter-youtube',
    creatorMarketertrackId: 'foam-creatormarketer-talent-filter-youtube',
  },
];

export const getFilterType = (activePlatform: ALL_SOCIAL_PLATFORM_TYPE) => {
  const filterType = {
    [SOCIAL_PLATFORMS.instagram]: FILTERS.igFollowers,
    [SOCIAL_PLATFORMS.tiktok]: FILTERS.ttFollowers,
    [SOCIAL_PLATFORMS.youtube]: FILTERS.ytFollowers,
    [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: FILTERS.scFollowers,
  };
  return filterType[activePlatform];
};

export const SearchByFollowers: React.FC = () => {
  const { activePlatform, setActivePlatform, setFilter, getFilter } =
    useAdvancedFiltersStore();

  useEffect(() => {
    return () => {
      // @ts-ignore
      setActivePlatform(PLATFORM_OPTIONS.selectPlatform);
    };
  }, [setActivePlatform]);

  const handlePlatformChange = useCallback(
    (value: any) => {
      const platform = value.value;
      setActivePlatform(platform);
      if (value.value === PLATFORM_OPTIONS.selectPlatform) {
        return; // when no platform is select skip the part of adding filter
      }

      const filterType = getFilterType(platform);
      const filterValue = getFilter(platform, filterType);

      setFilter(platform, filterType as any, filterValue || 0);
    },
    [getFilter, setActivePlatform, setFilter],
  );

  const { pathname } = useRouter();
  const isCreatorMarketerRoster = pathname.includes('/talent');

  return (
    <Flex flexDirection="column" gap={2}>
      <Flex flexDirection="column" gap={2}>
        <Text fontSize="lg" fontWeight="500" color="primary.500">
          Platform
        </Text>
        <Select
          onChange={handlePlatformChange}
          placeholder="Platform"
          value={activePlatform}
          defaultValue={selectOptions[0].value}
        >
          {selectOptions.map((option) => (
            <SelectOption
              key={option.value}
              value={option.value}
              icon={option.icon && <option.icon boxSize={4} />}
              trackId={
                isCreatorMarketerRoster
                  ? option.creatorMarketertrackId
                  : option.myAgencytrackId
              }
            >
              {option.label}
            </SelectOption>
          ))}
        </Select>
      </Flex>
      {(activePlatform as PLATFORM_OPTIONS) !==
        PLATFORM_OPTIONS.selectPlatform && (
        <Flex justifyContent="space-between" direction="column">
          <FollowersMetrics activePlatform={activePlatform} />
        </Flex>
      )}
    </Flex>
  );
};
